<script setup lang="ts">
import MxIconButton from './MxIconButton.vue';

export interface ShelfItem {
  id: string;
  icon?: string;
  emoji?: string;
  label: string;
  badge?: 'popular' | 'new';
}

defineProps<{
  items: ShelfItem[];
  activeId?: string | null;
  size?: 'md' | 'lg';
}>();

defineEmits<{ (e: 'update:activeId', id: string): void }>();
</script>

<template>
  <div class="shelf">
    <MxIconButton
      v-for="it in items"
      :key="it.id"
      :icon="it.icon"
      :emoji="it.emoji"
      :label="it.label"
      :badge="it.badge"
      :active="it.id === activeId"
      :size="size"
      @click="$emit('update:activeId', it.id)"
    />
  </div>
</template>

<style scoped>
.shelf {
  display: flex;
  gap: var(--sp-3);
  overflow-x: auto;
  scroll-snap-type: x proximity;
  padding: 4px 0 var(--sp-2);
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.shelf::-webkit-scrollbar { display: none; }
.shelf > * { scroll-snap-align: start; }
</style>
